export class LastUpdaterManagedValue<TValue, TUpdater> {
  constructor(private _value: TValue, private _lastUpdater: TUpdater) {
  }

  get value(): TValue {
    return this._value;
  }

  get lastUpdater(): TUpdater {
    return this._lastUpdater;
  }

  update(value: TValue, updater: TUpdater): void {
    this._value = value;
    this._lastUpdater = updater;
  }

  clone(): LastUpdaterManagedValue<TValue, TUpdater> {
    return new LastUpdaterManagedValue(this.value, this.lastUpdater);
  }
}
